// The server's fonts (chosen by its admins): one for headings, one for all other text.
// They're served by the server itself (/api/v1/fonts/{role}), so no other site is
// contacted; where none is set, the app's own (Lilex, style.css).

import type { ServerFont, ServerFonts } from '../api/types'
import { apiUrl } from '../platform'

const FAMILY = { heading: 'hrth-heading', text: 'hrth-text' } as const

/** The @font-face rules for the server's fonts (the URL carries the version). */
export function fontFaces(fonts: ServerFonts | undefined, prefix = apiUrl('')): string {
  const face = (role: keyof typeof FAMILY, f: ServerFont | undefined) =>
    f
      ? `@font-face { font-family: '${FAMILY[role]}'; src: url('${prefix}/fonts/${role}?v=${Math.trunc(f.version)}') format('${f.format}'); font-weight: 100 900; font-display: swap; }`
      : ''
  return [face('heading', fonts?.heading), face('text', fonts?.text)].filter(Boolean).join('\n')
}

/** Uses the server's fonts on this page (and goes back to the app's own where unset). */
export function applyFonts(fonts: ServerFonts | undefined): void {
  let style = document.getElementById('hrth-fonts') as HTMLStyleElement | null
  if (!style) {
    style = document.createElement('style')
    style.id = 'hrth-fonts'
    document.head.append(style)
  }
  style.textContent = fontFaces(fonts)
  const root = document.documentElement.style
  for (const role of ['heading', 'text'] as const) {
    if (fonts?.[role]) root.setProperty(`--app-font-${role}`, `'${FAMILY[role]}'`)
    else root.removeProperty(`--app-font-${role}`)
  }
}
